<style>

input[type="text"], input[type="password"], input[type="email"], input[type="number"], input[type="date"], textarea, select, .text-field {
  font-family: SenRegular;
  font-size: 20px;
  background-color: inherit;
  border: 0;
  border-bottom: 1px gray solid;
  height: 45px;
  border-radius: 0;
  width: 100%;
	padding: 7px 10px 6px 10px;
	box-sizing: border-box;
  outline: none;
  color: white;
}
input[type="text"].dark{
  color: black;
  border: 1px white solid;
  /* border-radius: 45px; */
  background-color: rgba(255,255,255,0.6);
}
input[type="text"].dark::placeholder{
  color: #555;
}
input[type="text"].text-no-line, input[type="password"].text-no-line, input[type="email"].text-no-line, input[type="number"].text-no-line, input[type="date"].text-no-line, textarea.text-no-line, select.text-no-line{
  border-bottom: none;
}
textarea{
  height: auto;
  min-height: 100px;
  border: 1px gray solid;
  border-radius: 23px;
}
.text-field{
	padding: 10px 10px 3px 10px;
}

img{
  object-fit: cover;
  width: 100%;
}
.images{
  position: relative;
  text-align: center;
  color: white;
}
.images-text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0,0,0,0.7);
  font-family: Sen;
  font-size: 24px;
  padding: 10px;
}

.tabs{
  margin: 10px 0;
}
.body{
  margin: 0 10px;
}

.price{
  display: grid;
  grid-template-columns: 16px auto;
  align-items: center;
  border-bottom: 1px gray solid;
}
.price-icon{
  grid-column: 1;
  font-size: 23px;
  margin-left: 10px;
}
.price-input{
  grid-column: 2;
}

.new-link-box{
  margin: 10px 0;
  padding: 6px 10px;
  border: 1px #0000 solid;
}
.selected{
  background-color: rgba(255,255,255,0.6);
  border: 1px white solid;
  /* box-shadow: 0 0 10px rgba(255,255,255,0.7); */
  color: black;
}

.margin{
  margin: 5px 0;
}
.label-margin{
  margin-top: 30px;
}
</style>


<Dialog show="{showStartCalendar}" title="Pick Start Date" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }" on:close="{ () => showStartCalendar = false }" on:done="{ dateDoneHelper }">
  <Calendar bind:date="{parsedStartDate}"></Calendar>
</Dialog>

<Dialog show="{showStartTime}" title="Pick Start Time" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }" on:close="{ () => showStartTime = false }" on:done="{ timeDoneHelper }">
  <TimePicker bind:time="{parsedStartTime}"></TimePicker>
</Dialog>

<Dialog show="{showEndCalendar}" title="Pick Date" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }" on:close="{ () => showEndCalendar = false }" on:done="{ dateDoneHelper }">
  <Calendar bind:date="{parsedEndDate}"></Calendar>
</Dialog>

<Dialog show="{showEndTime}" title="Pick Time" buttons="{ [ {text: 'Cancel', callback: 'close', disabled: false, }, {text: 'Done', callback: 'done', disabled: false, }, ] }" on:close="{ () => showEndTime = false }" on:done="{ timeDoneHelper }">
  <TimePicker bind:time="{parsedEndTime}"></TimePicker>
</Dialog>

<Dialog show="{addLink}" title="Add A Link For" buttons="{ addLinkButtons }" on:close="{ addLinkCancel }" on:done="{ addLinkDone }">
  
  <div class="new-link-box {newLink.icon == 'website' ? 'selected' : ''}" on:click="{ () => newLink.icon = 'website' }"><i class="icon-globe"></i> Website</div>
  <div class="new-link-box {newLink.icon == 'facebook' ? 'selected' : ''}" on:click="{ () => newLink.icon = 'facebook' }"><i class="icon-facebook"></i> Facebook</div>
  <div class="new-link-box {newLink.icon == 'instagram' ? 'selected' : ''}" on:click="{ () => newLink.icon = 'instagram' }"><i class="icon-instagram"></i> Instagram</div>
  <div class="new-link-box {newLink.icon == 'linkedin' ? 'selected' : ''}" on:click="{ () => newLink.icon = 'linkedin' }"><i class="icon-linkedin"></i> LinkedIn</div>
  <div class="new-link-box {newLink.icon == 'snapchat' ? 'selected' : ''}" on:click="{ () => newLink.icon = 'snapchat' }"><i class="icon-snapchat"></i> Snapchat</div>
  <div class="new-link-box {newLink.icon == 'twitter' ? 'selected' : ''}" on:click="{ () => newLink.icon = 'twitter' }"><i class="icon-twitter"></i> Twitter</div>
  
  {#if newLink.icon}
    <input type="text" class="dark" bind:value="{newLink.link}" placeholder="link" on:keyup="{newLinkChanged}">
  {/if}
  
</Dialog>



<Header 
back="{true}"
buttons="{ [  ] }"
on:back="{ () => { pop() } }">Create New Event</Header>
<div class="has-header"></div>

<div class="images">
  <img src="/i/create-new-event.jpg" alt="" class="img">
  <div class="images-text">
    + Add Images
  </div>
</div>

<div class="tabs">
  <PillTabs theme="dark" tabs="{ [ {name: 'Public', selected: true}, {name: 'Private', selected: false } ] }"></PillTabs>
</div>

<div class="body">
  
  <div class="label">Event Name / Venue</div>
  <div><input type="text" bind:value="{name}" placeholder="name"></div>
  
  <div class="label">Start Date and Time</div>
  <div class="text-field">
    <DateTimeInput datetime="{startDateTime}" on:showCalendar="{ () => showStartCalendar = true }" on:showTime="{ () => showStartTime = true }"></DateTimeInput>
  </div>
  
  <div class="label">End Date and Time</div>
  <div class="text-field">
    <DateTimeInput datetime="{endDateTime}" on:showCalendar="{ () => showEndCalendar = true }" on:showTime="{ () => showEndTime = true }"></DateTimeInput>
  </div>
  
  <div class="label">Phone</div>
  <div><input type="text" bind:value="{phone}" placeholder="phone"></div>
  
  <div class="label">Address (If different)</div>
  <div><input type="text" bind:value="{address}" placeholder="address"></div>
  
  <div class="label">Address 2</div>
  <div><input type="text" bind:value="{address2}" placeholder="address 2"></div>
  
  <div class="label">City</div>
  <div><input type="text" bind:value="{city}" placeholder="city"></div>
  
  <div class="label">State</div>
  <div><input type="text" bind:value="{state}" placeholder="state"></div>
  
  <div class="label">Zip</div>
  <div><input type="text" bind:value="{zip}" placeholder="zip"></div>
  
  <div class="label">Price</div>
  <div class="price">
    <div class="price-icon">$</div>
    <div class="price-input"><input type="number" class="text-no-line" bind:value="{price}" placeholder="price"></div>
  </div>
  
  <div class="label">Details</div>
  <div><textarea bind:value="{details}" placeholder="details"></textarea></div>
  
  <div class="label label-margin">Social Links</div>
  
  {#each links as item, index}
  <LinkInput icon="{item.icon}" link="{item.link}" index="{index}" on:delete="{deleteLink}"></LinkInput>
  {/each}
  
  <div class="margin">
    <button on:click="{ () => addLink = true }">+ Add Link</button>
  </div>
  
  <div class="label label-margin">Friends Invited</div>
  {#each invitedFriends as item, index }
  <FriendsInput oid="{item.oid}" name="{item.name}" index="{index}" on:delete="{deleteInvitedFriend}"></FriendsInput>
  {/each}
  <div class="margin">
    <button on:click="{ () => showInviteFriends = true }">+ Invite Friends</button>
  </div>
  <!-- is a dialog that is shown when showInviteFriends = true -->
  <FriendsPicker bind:show="{showInviteFriends}" bind:friends="{invitedFriends}" allFriends="{allFriends}"></FriendsPicker>
  
  
</div>

<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import PillTabs from "../components/PillTabs.svelte";
import Calendar from "../components/Calendar.svelte";
import TimePicker from "../components/TimePicker.svelte";
import Dialog from "../components/Dialog.svelte";
import DateTimeInput from "../components/DateTimeInput.svelte";
import LinkInput from "../components/LinkInput.svelte";
import FriendsInput from "../components/FriendsInput.svelte";
import FriendsPicker from "../components/FriendsPicker.svelte";

let showStartCalendar = false;
let showStartTime = false;
let showEndCalendar = false;
let showEndTime = false;
let addLink = false;
let newLink = {icon: "", link: ""};
let addLinkButtons = [ 
  {text: 'Cancel', callback: 'close', disabled: false, }, 
  {text: 'Done', callback: 'done', disabled: true, }, 
];

let showInviteFriends = false;

let name = "The Grove";
let startDateTime = "2024-02-29 16:20:00";
let parsedStartDate = "";
let parsedStartTime = "";
let endDateTime = "2024-02-29 17:20:00";
let parsedEndDate = "";
let parsedEndTime = "";
let phone = "213-000-0000";
let address = "1234 Main St";
let address2 = "";
let city = "Los Angeles";
let state = "CA";
let zip = "90000";
let price = 21;
let details = "";
let links = [
  {icon: "instagram", link: "@TheGroveLA"},
  {icon: "website", link: "thegrovela.com"},
];
// a list of friend obfuscatedIds
let invitedFriends = [
  {oid: "0006", name: "Rose Alibaster"},
];

// a list of friend obfuscatedIds
let cohosts = [];

let allFriends = [
  {oid: "0004", name: "James Smith"},
  {oid: "0005", name: "Lena Williamson"},
  {oid: "0006", name: "Rose Alibaster"},
];

$:{
  if (startDateTime || endDateTime) {
    getDate(startDateTime, endDateTime)
  }
}


function getDate(startDateTime, endDateTime) {
  parsedStartDate = startDateTime.split(" ")[0];
  parsedStartTime = startDateTime.split(" ")[1];
  parsedEndDate = endDateTime.split(" ")[0];
  parsedEndTime = endDateTime.split(" ")[1];
}


function dateDoneHelper() {
  let tdate = startDateTime.split(" ");
  tdate[0] = parsedStartDate;
  startDateTime = tdate.join(" ");
  
  tdate = endDateTime.split(" ");
  tdate[0] = parsedEndDate;
  endDateTime = tdate.join(" ");
  
  showStartCalendar = false;
  showEndCalendar = false;
}


function timeDoneHelper() {
  let tdate = startDateTime.split(" ");
  tdate[1] = parsedStartTime;
  startDateTime = tdate.join(" ");

  tdate = endDateTime.split(" ");
  tdate[1] = parsedEndTime;
  endDateTime = tdate.join(" ");

  showStartTime = false;
  showEndTime = false;
}


function addLinkCancel() {
  newLink = {icon: "", link: ""};
  addLink = false;
}

function addLinkDone() {
  links.push( JSON.parse( JSON.stringify( newLink ) ) );
  links = links;
  newLink = {icon: "", link: ""};
  addLink = false;
}


function deleteLink(e) {
  links.splice(e.detail.index, 1);
  links = links;
}


function newLinkChanged() {
  if (newLink.link == "") {
    addLinkButtons[1].disabled = true;
  } else {
    addLinkButtons[1].disabled = false;
  }
}


function deleteInvitedFriend(e) {
  // deselect friends from allFriends (used in FriendPicker.svelte)
  for (let i in allFriends) {
    if (allFriends[i].oid == invitedFriends[e.detail.index].oid) {
      allFriends[i].selected = false;
      break;
    }
  }
  invitedFriends.splice(e.detail.index, 1);
  invitedFriends = invitedFriends;
}

</script>